module.exports = __webpack_public_path__ + "left-arrow-black.png?3d136b26bbb01a99c6f9bdfca806fdfb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/left-arrow-black.png
// module id = 678
// module chunks = 0 2 7 8 9 10